import React from 'react'
import BaseComponent from "../../pages/base/BaseComponent";
import PropTypes from "prop-types";
import {isEmpty, navigate} from "enqc-utilities/src/utils/Utilities";
import label from "enqc-utilities/src/label/Label";
import {Button, Card, Col, Row} from "@themesberg/react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTasks} from "@fortawesome/free-solid-svg-icons";
import {ASSEMBLY_STATUS_COLOR, ON_PROGRESS, OPEN, QC_RETURNED} from "enqc-utilities/src/utils/Global";
import {getUser} from "../../utils/StorageUtil";
import ContinueAssemblyConfirmationModal from "../ContinueAssemblyConfirmationModal";
import AssemblyFormControlPage from "../../pages/business/AssemblyFormControlPage";

export default class AssemblyBasicInformationCard extends BaseComponent{

    constructor(props) {
        super(props);
        let {assembly} = this.props
        if(isEmpty(assembly)){
            assembly = {}
        }
        this.setState({assembly, continueAssemblyConfirmationModal:false})
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps!=this.props){
            let {assembly} = nextProps
            if(isEmpty(assembly)){
                assembly = {}
            }
            this.setState({assembly})
        }
    }

    render() {
        let user = getUser()
        let {assembly, continueAssemblyConfirmationModal} = this.state
        if(isEmpty(assembly)){
            assembly = {}
        }
        let model = assembly.model?assembly.model:{}
        let assemblyStatus = assembly.assemblyStatus
        if(isEmpty(assemblyStatus)){
            assemblyStatus = {}
        }
        let mine = getUser()


        let statusButtonDisable = true ;
        if(assemblyStatus.id===ON_PROGRESS && user.id===mine.id){
            statusButtonDisable = false ;
        }else if(assemblyStatus.id===OPEN){
            statusButtonDisable = false ;
        }else if(assemblyStatus.id===QC_RETURNED){
            statusButtonDisable = false ;
        }
        let serialComponent = assembly.serialComponent?assembly.serialComponent:{}
        let rectifierControllerEntry = assembly.rectifierControllerEntry?assembly.rectifierControllerEntry:{}

        return (
            <Row>
                <ContinueAssemblyConfirmationModal
                    postProcessingRef={this.props.postProcessingRef}
                    show={continueAssemblyConfirmationModal}
                    model={model}
                    assembly={assembly}
                    reference={assembly.reference}
                    onClose={() => {
                        this.setState({continueAssemblyConfirmationModal:false})
                    }}
                    onResult={(assembly) => {
                        this.setState({continueAssemblyConfirmationModal:false}, () => {
                            navigate(this.props, AssemblyFormControlPage.ENDPOINT+"?reference="+assembly.reference)
                        })
                    }}/>
                <Col lg={3} xs={6}>
                    <Card border="light" className="card-equal-height bg-white shadow-sm mb-4">
                        <Card.Body>
                            <Row className="mb-3">
                                <Col className="text-center">
                                    <span>{label.Reference}</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="text-center">
                                    <span><h2 className="text-info">{assembly.reference?assembly.reference:0}</h2></span>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
                <Col lg={3} xs={6}>
                    <Card border="light" className="card-equal-height bg-white shadow-sm mb-4">
                        <Card.Body>
                            <Row className="mb-3">
                                <Col className="text-center">
                                    <span>{label.ComponentSize}</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="text-center">
                                    <span><h2 className="text-info">{serialComponent.componentSize}</h2></span>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
                <Col lg={3} xs={6}>
                    <Card border="light" className="card-equal-height bg-white shadow-sm mb-4">
                        <Card.Body>
                            <Row className="mb-3">
                                <Col className="text-center">
                                    <span>{label.RectifierControllerSize}</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="text-center">
                                    <span><h2 className="text-info">{rectifierControllerEntry.sizeOfRectifierControllerSerialNumber}</h2></span>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
                <Col lg={3} xs={6}>
                    <Card border="light" className="card-equal-height bg-white shadow-sm mb-4">
                        <Card.Body>
                            <Row className="mb-2">
                                <Col className="text-center">
                                    <span><h3 style={{color:ASSEMBLY_STATUS_COLOR[assemblyStatus.name]}}>{assemblyStatus.name?assemblyStatus.name:label.Status}</h3></span>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="text-center">
                                    <Button
                                        variant="white"
                                        className={"d-block w-100 "+(statusButtonDisable?"btn-outline-gray":"btn-outline-success")}
                                        disabled={statusButtonDisable}
                                        onClick={(event) => {
                                            event.preventDefault()
                                            this.setState({continueAssemblyConfirmationModal:true})

                                        }}>
                                        {label.Continue}
                                        &nbsp;
                                        <FontAwesomeIcon icon={faTasks} size="sm" />
                                    </Button>

                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        );
    }

}

AssemblyBasicInformationCard.propTypes = {
    assembly : PropTypes.any,
}